import { Injectable } from '@angular/core';

import { EpcotConfig } from '@frontend/sports/common/client-config-data-access';
import { DialogAnimation } from '@frontend/sports/modal/feature';
import { RedirectHelperService } from '@frontend/sports/navigation/core/feature/redirect';
import { ModelPopupTypes } from '@frontend/sports/navigation/core/feature/url-helper';
import { PopupManager } from 'packages/sports/web/app/src/popup/popup-manager.service';

import { IBetslipSourcePageState, SourcePageType } from '../../../model/edit-mybet/edit-bet-init';

@Injectable()
export class BetslipSourcePageService {
    constructor(
        private redirectHelper: RedirectHelperService,
        private popupManager: PopupManager,
        private epcotConfig: EpcotConfig,
    ) {}

    applySourcePageState(state: IBetslipSourcePageState, isEditBetResult: boolean = false): void {
        switch (state.pageType) {
            case SourcePageType.Event:
                if (state.options === null) {
                    throw new Error('Options should be filled for the SourcePageType.Event page type');
                }

                this.redirectHelper.goToEvent({ id: state.options.eventId, name: state.options.eventName }, state.options.market);
                break;

            case SourcePageType.MyBets:
                if (this.epcotConfig.isEnabled) {
                    if (isEditBetResult) {
                        this.popupManager.updateDialogAnimation(ModelPopupTypes.MyBets, DialogAnimation.SlideInFromRight);
                    } else {
                        this.popupManager.updateDialogAnimation(ModelPopupTypes.MyBets, undefined, false, true);
                        this.popupManager.open(ModelPopupTypes.MyBets);
                    }
                } else {
                    this.redirectHelper.goToMyBets();
                }
                break;

            case SourcePageType.None:
                break;

            default:
                throw new Error(`Unknown SourcePageType: ${state.pageType}`);
        }
    }
}
